import { useState, useEffect } from 'react';
import { splitJKCoreTests } from '@/config/batteries';
import { getCommercialName } from '@/config/batteries';
import type { OfficialTest } from '@/config/batteries';

export interface BatterySelectorListProps {
  tests: OfficialTest[];
  selected: string[];
  onToggle: (testId: string) => void;
  isDisabled?: (testId: string) => boolean;
  /** Si true, el grupo JK-Core empieza expandido (p. ej. cuando hay preselección). */
  jkGroupExpandedByDefault?: boolean;
}

export function BatterySelectorList({
  tests,
  selected,
  onToggle,
  isDisabled = () => false,
  jkGroupExpandedByDefault = false,
}: BatterySelectorListProps) {
  const { jkTests, otherTests } = splitJKCoreTests(tests);
  const jkSelectedCount = jkTests.filter((t) => selected.includes(t.testId)).length;
  const [jkExpanded, setJkExpanded] = useState(jkGroupExpandedByDefault || jkSelectedCount > 0);

  // Expandir cuando hay JK preseleccionados (p. ej. tras aplicar preset)
  useEffect(() => {
    if (jkSelectedCount > 0) setJkExpanded(true);
  }, [jkSelectedCount]);

  return (
    <ul className="space-y-2">
      {otherTests.map((t) => {
        const disabled = isDisabled(t.testId);
        return (
          <li key={t.testId} className="flex items-center gap-2">
            <input
              type="checkbox"
              id={`test-${t.testId}`}
              checked={selected.includes(t.testId)}
              disabled={disabled}
              onChange={() => onToggle(t.testId)}
              className="h-4 w-4 rounded border-input"
            />
            <label
              htmlFor={`test-${t.testId}`}
              className={`text-sm ${disabled ? 'cursor-not-allowed text-muted-foreground' : 'cursor-pointer'}`}
            >
              {getCommercialName(t.testId)}
            </label>
          </li>
        );
      })}
      {jkTests.length > 0 && (
        <li className="flex flex-col">
          <button
            type="button"
            onClick={() => setJkExpanded((e) => !e)}
            className="flex items-center gap-2 rounded-md px-1 py-1.5 text-left text-sm hover:bg-muted/50"
          >
            <span className="text-muted-foreground">
              {jkExpanded ? '▾' : '▸'}
            </span>
            <span>
              Conocimiento del puesto (JK-Core)
              {jkSelectedCount > 0 && (
                <span className="ml-1.5 rounded-full bg-primary/10 px-2 py-0.5 text-xs font-medium text-primary">
                  {jkSelectedCount}
                </span>
              )}
            </span>
          </button>
          {jkExpanded && (
            <ul className="ml-6 mt-1 space-y-1.5 border-l-2 border-muted pl-3">
              {jkTests.map((t) => {
                const disabled = isDisabled(t.testId);
                return (
                  <li key={t.testId} className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      id={`test-${t.testId}`}
                      checked={selected.includes(t.testId)}
                      disabled={disabled}
                      onChange={() => onToggle(t.testId)}
                      className="h-4 w-4 rounded border-input"
                    />
                    <label
                      htmlFor={`test-${t.testId}`}
                      className={`text-sm ${disabled ? 'cursor-not-allowed text-muted-foreground' : 'cursor-pointer'}`}
                    >
                      {getCommercialName(t.testId)}
                    </label>
                  </li>
                );
              })}
            </ul>
          )}
        </li>
      )}
    </ul>
  );
}
